import React from 'react';
import { IIconProps } from './utils';

export const Discuss = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M14.1408 4C14.1408 3.30964 14.7005 2.75 15.3908 2.75C19.4552 2.75 23.8832 4.38794 26.1128 8.74432C26.4273 9.35886 26.1841 10.112 25.5695 10.4265C24.955 10.7411 24.2018 10.4978 23.8873 9.88329C22.2201 6.62581 18.8548 5.25 15.3908 5.25C14.7005 5.25 14.1408 4.69036 14.1408 4ZM11.5211 4.60005C11.8248 5.22001 11.5685 5.9688 10.9485 6.27252C7.69733 7.86534 5.48911 11.1377 5.48911 14.8947C5.48911 16.1575 5.73759 17.361 6.18883 18.4637C6.53318 19.3051 6.65348 20.3168 6.3118 21.297L5.01693 25.0116L8.92782 23.7104C9.87102 23.3966 10.8402 23.5061 11.6553 23.8298C12.1119 24.0112 12.5855 24.1602 13.0734 24.2742C13.7457 24.4311 14.1635 25.1033 14.0065 25.7756C13.8496 26.4479 13.1773 26.8656 12.5051 26.7087C11.8957 26.5664 11.3036 26.3801 10.7325 26.1533C10.3509 26.0018 9.99566 25.9899 9.71704 26.0826L5.72577 27.4105C3.78948 28.0547 1.95666 26.1956 2.62836 24.2687L3.95112 20.4741C4.05166 20.1856 4.03956 19.8125 3.87508 19.4105C3.30332 18.0134 2.98911 16.4887 2.98911 14.8947C2.98911 10.1244 5.79491 6.01347 9.84863 4.02748C10.4686 3.72375 11.2174 3.9801 11.5211 4.60005Z"
      fill={fill}
      fillRule="evenodd"
    />
    <path
      d="M13 18.2411C13 22.2402 16.2419 25.4821 20.2411 25.4821C21.2932 25.4821 22.293 25.2577 23.1951 24.8541C23.4324 24.748 23.7008 24.7249 23.9469 24.8088L28 26L26.8088 21.9469C26.7249 21.7008 26.748 21.4324 26.8541 21.1951C27.2577 20.293 27.4821 19.2932 27.4821 18.2411C27.4821 14.2419 24.2402 11 20.2411 11C16.2419 11 13 14.2419 13 18.2411Z"
      fill={fill}
    />
  </svg>
);
